module.exports = __webpack_public_path__ + "img/OBCINA HRPELJE-KOZINA.5f04dac3.png";